import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminAuthProvider } from '../contexts/AdminAuthContext';
import { ClientPortalProvider } from '../contexts/ClientPortalContext';

// Import des composants de page
import ProductCatalog from './pages/ProductCatalog';
import AdminPage from './pages/AdminPage';

const AppRouter = () => {
    return (
        <Routes>
            {/* Route principale - Catalogue produits */}
            <Route 
                path="/" 
                element={
                    <ClientPortalProvider>
                        <ProductCatalog />
                    </ClientPortalProvider>
                } 
            />
            
            {/* Routes Admin */}
            <Route 
                path="/admin/*" 
                element={
                    <AdminAuthProvider>
                        <AdminPage />
                    </AdminAuthProvider>
                } 
            />
            
            {/* Redirection pour toute route inconnue */}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

export default AppRouter;
